import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GET_DOCUMENT_LIST_STORE_NAME, GetDocumentListState } from './get-document-list.state';

/** Select GetDocumentList State */
export const selectGetDocumentListState = createFeatureSelector<GetDocumentListState>(GET_DOCUMENT_LIST_STORE_NAME);

/** Select GetDocumentList isPending status */
export const selectGetDocumentListIsPendingStatus = createSelector(
  selectGetDocumentListState,
  (state) => !!state.isPending
);

/** Select GetDocumentList isFailure status */
export const selectGetDocumentListIsFailureStatus = createSelector(
  selectGetDocumentListState,
  (state) => !!state.isFailure
);
